module.exports = __webpack_public_path__ + "static/img/section_04_next_level_kv.ed5014b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/overview/section_04_next_level_kv.png
// module id = ATCE
// module chunks = 13